import React from 'react';
import LegalPage from './components/LegalPage';
import { TERMS_OF_USE_HTML } from './data/legalContent';

export default function TermsOfUsePage() {
  return <LegalPage title="Terms of Use" html={TERMS_OF_USE_HTML} />;
}
